import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { AccountService, loanDetail } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Base64 } from 'js-base64';
import { saveAs } from 'file-saver';
import { CardServiceService } from '../Services/card-service.service';
import { TopupServiceService } from '../Services/topup-service.service';
import { CookieService } from '../Services/cookie';
import { ToastrService } from "ngx-toastr";
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';



@Component({
  selector: "app-dashboard-loans",
  templateUrl: "./dashboard-loans.component.html",
  standalone:false,
  styleUrls: ["./dashboard-loans.component.scss"],
})
export class DashboardLoansComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  selectedMonth: string = "";
  Monthlist;
  // loanDetail;
  loanDetail: any[] = undefined;
  selectedLoanDetail: loanDetail;
  ViewStatementList;
  MonthYear: string = "";
  UnGroupLoanTransactionHistory;
  GroupLoanTransactionHistory;
  selectedLoanIndex: number;
  TransactionHistory;
  nameFromNickName: string;
  ViewGroupTransaction: boolean = false;
  SelectedtransactionDetail;
  totalslidervalues: string[] = [];
  LoanYear: number = 0;
  LoanMonths: number = 0;
  serviceType: string
  LettersList;
  RLServiceid;
  PaymentDetail;
  TotalAmount: number = 0;
  PaymentRequired;
  transactionRefId: string = "";
  internalId: string;
  Home: string;
  transactionDateOnly: any;
  transactionTimeOnly: any;
  outstandingAmount: any;
  maxOutstandingAmount: any;
  progressValue: number;

  carouselOptions: OwlOptions = {
    loop: false,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };

  constructor(
    private auth: AuthService,
    public commonP: CommonService,
    private account: AccountService,
    private _router: Router, public datepipe: DatePipe,
    public cardService: CardServiceService,
    private topupservice: TopupServiceService,
    private cookieService: CookieService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {
    // this.toastr.success(
    //   "You have succesfully added nickname to your selected loan",
    //   "Loan Nickname Added"
    // );
    // this.toastr.success(
    //   "You have succesfully updated the nickname of your selected loan",
    //   "Loan Nickname Updated"
    // );
    // this.toastr.success(
    //   "You have successfully removed the nickname of your selected loan",
    //   "Loan Nickname Removed"
    // );
  }

  async ngOnInit(): Promise<void> {

    this.serviceType = await this.cookieService.get("sTyp", true);
    //this.cdr.detectChanges();
    console.log("serviceTypeData", this.serviceType);
    let Id =await this.cookieService.get("InternalId", false);

    if (Id) {
      this.internalId = Id;

    }
    let H =await this.cookieService.get("Home", true);

    if (H) {
      this.Home = H;
    }


    this.Monthlist = [
      {
        iconClass: "",
        displayValue: "January",
      },
      {
        iconClass: "",
        displayValue: "Febuary",
      },
      {
        iconClass: "",
        displayValue: "March",
      },
      {
        iconClass: "",
        displayValue: "April",
      },
      {
        iconClass: "",
        displayValue: "May",
      },
      {
        iconClass: "",
        displayValue: "June",
      },
      {
        iconClass: "",
        displayValue: "July",
      },
      {
        iconClass: "",
        displayValue: "August",
      },
      {
        iconClass: "",
        displayValue: "September",
      },
      {
        iconClass: "",
        displayValue: "October",
      },
      {
        iconClass: "",
        displayValue: "November",
      },
      {
        iconClass: "",
        displayValue: "December",
      },
    ];

    if (this.account.getDashboardDetail?.loanDetails == undefined) {
      this.auth.accessToken = await this.commonP.Get("token");
      await this.commonP.presentLoading();
      this.auth
        .VerifyToken({}, this.auth.accessToken)
        .then(async (data: any) => {
          if (data?.response) {
            if (data?.response?.code) {
              if (data?.response?.code == 1) {
                this.account
                  .GetLoanDashboard(this.auth.accessToken)
                  .then((data: any) => {
                    if (data?.response?.code == 1) {

                      // loan outstanding amount
                      console.log("loandata1", data);

                      this.outstandingAmount = data?.response?.content?.loanDetails[0]?.outstandingBalance;
                      this.maxOutstandingAmount = data?.response?.content?.loanDetails[0]?.loanAmount
                      console.log("outstandingAmount1",this.outstandingAmount);
                      console.log("maxOutstandingAmount1",this.outstandingAmount);
                      
                      let percentage = (this.outstandingAmount / this.maxOutstandingAmount) * 100;
                      if (percentage > 100) {
                        percentage = 100;
                      }
                      if (this.outstandingAmount === 0) {
                        percentage = 100;
                      }
                      this.progressValue = Math.round(percentage);

                      // loan outstanding amount

                      let LoanDetails = data.response.content.loanDetails;
                      this.loanDetail = LoanDetails.filter(
                        (x) => x.displayFlag == "Y"
                      );
                      for (let item of this.loanDetail) {
                        let cal =
                          Number(item.loanAmount - item.outstandingBalance) /
                          100;
                        if (cal < 0) {

                          this.totalslidervalues.push("0");
                        }
                        else {
                          this.totalslidervalues.push(cal.toString());
                        }
                        // this.totalslidervalues.push(cal.toString());
                      }

                      if (this.internalId != undefined && this.internalId != "" && this.Home == 'Home') {

                        this.loanDetail.filter((x, index) => {
                          if (x.internalId == this.internalId) {
                            // let L = x
                            this.selectedLoanDetail = x;
                            this.loanDetail.splice(index, 1);

                            this.loanDetail.unshift(x);

                            // this.selectedCard = index;
                            this.selectCard(0);
                          }

                        });

                      }
                      else {

                        this.selectedLoanDetail = this.loanDetail[0];
                        if (!this.selectedLoanDetail) {
  this.commonP.hideLoading();
  return; // Aage mat jao agar loan nahi hai
}


                        // if (Number(this.selectedLoanDetail.tenure) % 12 == 0) {
                        // Naya
                       if (this.selectedLoanDetail && Number(this.selectedLoanDetail.tenure) % 12 == 0) {
                          this.LoanYear =
                            Number(this.selectedLoanDetail.tenure) / 12;
                          this.LoanMonths = 0;
                        } else {
                          let Calculateloan =
                            Number(this.selectedLoanDetail.tenure) / 12;
                          this.LoanYear = Math.floor(Calculateloan);

                          let LoanMonths = Calculateloan.toString().split(".")[1];
                          this.LoanMonths = Number(String(LoanMonths)[0]);
                        }


                        if (this.loanDetail.length > 0) {

                          let body = {
                            internalId: this.selectedLoanDetail?.internalId,
                            numberOfTransactions: "10",
                          };
                          this.account
                            .GetTransactionUngroup(body, this.auth.accessToken)
                            .then((data: any) => {
                              if (data?.response?.code == 1) {
                                this.commonP.hideLoading();
                                let LoanTransactionHistory =
                                  data.response.content.loanTransactions;
                                this.UnGroupLoanTransactionHistory =
                                  LoanTransactionHistory;
                                this.selectedLoanIndex = 0;
                              } else {
                                this.commonP.hideLoading();
                                this.commonP.ParseErrorAlert(
                                  "",
                                  "",
                                  this._router,
                                  data
                                );
                              }
                            });
                        }
                        else {
                          this.commonP.hideLoading();
                        }
                      }
                      console.log('selectedLoanDetail', this.selectedLoanDetail)


                    } else {
                      this.commonP.hideLoading();
                      this.commonP.ParseErrorAlert("", "", this._router, data);
                    }
                  });
              } else {
                await this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            } else {
              await this.commonP.hideLoading();
              this.commonP.ParseErrorAlert("", "", this._router, data);
            }
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
            this.cdr.detectChanges();
    } else {

      let LoanDetail = this.account.getDashboardDetail?.loanDetails;
      this.loanDetail = LoanDetail.filter((x) => x.displayFlag == "Y");
      

       // loan outstanding amount
                      console.log("loandata2", this.loanDetail);

                      this.outstandingAmount = this.loanDetail[0]?.outstandingBalance;
                      this.maxOutstandingAmount = this.loanDetail[0]?.loanAmount
                       console.log("outstandingAmount2",this.outstandingAmount);
                      console.log("maxOutstandingAmount2",this.outstandingAmount);
                      let percentage = (this.outstandingAmount / this.maxOutstandingAmount) * 100;
                      if (percentage > 100) {
                        percentage = 100;
                      }
                      if (this.outstandingAmount === 0) {
                        percentage = 100;
                      }
                      this.progressValue = Math.round(percentage);

                      // loan outstanding amount

      if (this.internalId != undefined && this.internalId != "" && this.Home == 'Home') {

        this.loanDetail.filter((x, index) => {
          if (x.internalId == this.internalId) {
            // let L = x
            this.selectedLoanDetail = x;

            this.loanDetail.splice(index, 1);

            this.loanDetail.unshift(x);
            this.selectCard(0);

          }
        });
        // let L = this.loanDetail.filter(x=> x.internalId == this.internalId);
        // this.selectedLoanDetail = L[0];

      }
      else {

        this.selectedLoanDetail = this.loanDetail[0];
        if (!this.selectedLoanDetail) {
  this.commonP.hideLoading();
  return; // Aage mat jao agar loan nahi hai
}

        // if (Number(this.selectedLoanDetail.tenure) % 12 == 0) {
        // Naya
if (this.selectedLoanDetail && Number(this.selectedLoanDetail.tenure) % 12 == 0) {
          this.LoanYear = Number(this.selectedLoanDetail.tenure) / 12;
          this.LoanMonths = 0;
        } else {
          let Calculateloan = Number(this.selectedLoanDetail.tenure) / 12;
          this.LoanYear = Math.floor(Calculateloan);

          let LoanMonths = Calculateloan.toString().split(".")[1];
          this.LoanMonths = Number(String(LoanMonths)[0]);
        }
        this.commonP.presentLoading();
        if (this.loanDetail.length > 0) {
          let body = {
            internalId: this.selectedLoanDetail?.internalId,
            numberOfTransactions: null,
          };
          this.account
            .GetTransactionUngroup(body, this.auth.accessToken)
            .then((data: any) => {
              if (data?.response?.code == 1) {
                this.commonP.hideLoading();
                let LoanTransactionHistory =
                  data.response.content.loanTransactions;
                this.UnGroupLoanTransactionHistory = LoanTransactionHistory;
                this.selectedLoanIndex = 0;
              } else {
                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            });
        } else {
          this.commonP.hideLoading();
        }

      }


      for (let item of this.loanDetail) {
        let cal = Number(item.loanAmount - item.outstandingBalance) / 100;
        if (cal < 0) {

          this.totalslidervalues.push("0");
        }
        else {
          this.totalslidervalues.push(cal.toString());
        }
        // this.totalslidervalues.push(cal.toString());
      }

      // ('Else',this.selectedLoanDetail);
        this.cdr.detectChanges();
    }
    this.cdr.detectChanges();
  }


  onMonthChange(event) {
    this.selectedMonth = event.displayValue;
  }

  showModal(num, data) {
    //

    this.modalObservable.next(num);
    if (num == 10) {
      this.SelectedtransactionDetail = data;
      console.log('SelectedtransactionDetail', this.SelectedtransactionDetail)
      if (this.SelectedtransactionDetail?.transactionDate) {
        const dateTime = this.SelectedtransactionDetail.transactionDate.split(" ");
        this.transactionDateOnly = dateTime[0]; // Date extract
        this.transactionTimeOnly = dateTime[1]; // Time extract
      }
    }
    if (num == 11) {
      this.GetLettersList();
    }
  }

  paymenthistory() {
    this._router.navigateByUrl("/LoanPaymentHistory");
  }

  selectedCard: number = 0;
  /**
   * Resolves the slide index from either an owl-carousel-o event payload
   * (SlidesOutputData: { startPosition, slides }) or a plain index passed by
   * internal callers such as selectCard(0).
   */
  private resolveCardIndex(e): number {
    if (typeof e === "number") {
      return e;
    }
    if (e && typeof e.startPosition === "number") {
      return e.startPosition;
    }
    return null;
  }

  async selectCard(e) {

    const index = this.resolveCardIndex(e);
    // Bail out rather than fall through with an undefined loan: the tenure
    // maths below dereferences selectedLoanDetail without a guard.
    if (index == null || !this.loanDetail?.[index]) {
      return;
    }

    this.commonP.presentLoading();

    if (!this.GroupLoanTransactionHistory) {

      {

        this.selectedLoanDetail = this.loanDetail[index];


      // loan outstanding amount
      this.outstandingAmount = this.loanDetail[index]?.outstandingBalance
      this.maxOutstandingAmount = this.loanDetail[index]?.loanAmount
       console.log("outstandingAmount3",this.outstandingAmount);
                      console.log("maxOutstandingAmount3",this.outstandingAmount);
      let percentage = (this.outstandingAmount / this.maxOutstandingAmount) * 100;
      if (percentage > 100) {
        percentage = 100;
      }
      if (this.outstandingAmount === 0) {
        percentage = 100;
      }
      this.progressValue = Math.round(percentage);
      // loan outstanding amount

      }

      console.log('selectedLoanDetail', this.selectedLoanDetail)
      this.selectedCard = index;

      // if (Number(this.selectedLoanDetail.tenure) % 12 == 0) {
      // Naya
if (this.selectedLoanDetail && Number(this.selectedLoanDetail.tenure) % 12 == 0) {
        this.LoanYear = Number(this.selectedLoanDetail.tenure) / 12;
        this.LoanMonths = 0;
      } else {
        let Calculateloan = Number(this.selectedLoanDetail.tenure) / 12;
        this.LoanYear = Math.floor(Calculateloan);

        let LoanMonths = Calculateloan.toString().split(".")[1];
        this.LoanMonths = Number(String(LoanMonths)[0]);
      }

      let body = {
        internalId: this.selectedLoanDetail?.internalId,
        numberOfTransactions: null,
      };

      await this.account.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {

        if (data?.response?.code == 1) {

          let LoanTransactionHistory = data.response.content.loanTransactions;

          this.UnGroupLoanTransactionHistory = LoanTransactionHistory;
          this.selectedLoanIndex = 0;
          this.commonP.hideLoading();

        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
    }
    else if (this.GroupLoanTransactionHistory) {

      this.onTrasactionsChange();
    }
  }

  onTrasactionsChange() {

    this.commonP.presentLoading();

    let body = {
      internalId: this.selectedLoanDetail?.internalId,
      numberOfTransactions: 0,
    };
    this.account
      .GetTransactiongroup(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {

          this.ViewGroupTransaction = true;
          // this.UnGroupLoanTransactionHistory = [];
          let GroupLoanTransactionHistory = data?.response?.content;
          this.GroupLoanTransactionHistory = GroupLoanTransactionHistory;

          this.commonP.hideLoading();
          console.log("transection", this.GroupLoanTransactionHistory);

          // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
          // this.selectedCardDetail=this.cardDetail[0];
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  trackByFn(index: number, item: any): any {
    return item?.id || index; // Unique identifier for efficient rendering
  }

  formatDate(dateString: string): Date | null {
    if (!dateString) return null;
    const parts = dateString.split(/[/ :]/);
    const day = +parts[0], month = +parts[1] - 1, year = +parts[2];
    const hours = +parts[3], minutes = +parts[4], seconds = +parts[5];
    return new Date(year, month, day, hours, minutes, seconds);
  }
  ViewStatement(num) {
    let body = {
      internalId: this.selectedLoanDetail?.internalId,
      numberOfTransactions: 10,
      transactionType: "Statement",
      downloadType: "Data",
      email: false,
      emailId: "",
    };

    this.commonP.presentLoading();
    this.account
      .GetLoanStatement(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.ViewStatementList = data.response.content.lst;
          this.showModal(num, "");
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  back() {
    this.ViewGroupTransaction = false;
  }
  DownloadStatement() {
    let body = {
      internalId: this.selectedLoanDetail?.internalId,
      numberOfTransactions: null,
      // transactionType: "download",
      transactionType: "STATEMENT",
      // downloadType: "pdf",
      downloadType: "base64",
      email: false,
      emailId: "",
    };

    this.commonP.presentLoading();
    this.account
      .GetLoanStatement(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          // For Download file
          let decodedData = Base64.decode(data.response.content.base64);
          let blob = new Blob([decodedData], { type: "application/pdf" });
          saveAs(blob, data.response.content.fileName);

          // For Open in new tab

          // let fileUrl = URL.createObjectURL(blob);
          // window.open(fileUrl, '_blank');
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  showSuccessModal(num) { }
  cardReplacementSuccess() { }
  async GetLettersList() {
    await this.commonP.presentLoading();
    this.cardService
      .GetLettersList({ Product: "L" }, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.LettersList = data?.response.content.letterServicesList;
          console.log("GetLettersList", data);
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  requestLetterSelectedItem(item) {
    console.log("requestLetterSelectedItem", item);
    this.RLServiceid = item?.srvc;
    this.showModal("close", "");
    this.CheckLettersEligibility();
  }

  CheckLettersEligibility() {
    //
    let body = {
      internalId: this.selectedLoanDetail?.internalId,
      Type: "2", // 1 for card, 2 for loan
      ServiceType: this.RLServiceid, // map srvc key, coming from GetLetterList api
      Status: "STATUSCHECK",
    };

    this.commonP.presentLoading();
    this.cardService
      .CheckLettersEligibility(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          //
          this.commonP.hideLoading();
          this.PaymentDetail = data?.response?.content;
          this.TotalAmount =
            Number(this.PaymentDetail?.charges) +
            Number(this.PaymentDetail?.vat);

          if (
            data?.response?.content?.pendingRequestIndicator == "Y" &&
            Number(data?.response?.content?.charges) == 0
          ) {
            //  customer not eligibil
            let pendingRequest = true;
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { pendingRequest },
            });
          } else if (
            data?.response?.content?.pendingRequestIndicator == "N" &&
            Number(data?.response?.content?.charges) == 0
          ) {
            // Customer is Eligible No Payment Required

            this.LettersRequest();
          } else if (
            data?.response?.content?.pendingRequestIndicator == "N" &&
            Number(data?.response?.content?.charges) > 0
          ) {
            // Customer is Eligible  Payment Required
            this.PaymentRequired = true;
            this.showModal("close", "");
            this.showModal(12, "");
          }
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  InititePaymentService() {
    let body = {
      InternalId: this.selectedLoanDetail?.internalId,
      VendorId: 1, // 1 for benefit gateway, 2 for benefit pay
      AccountType: "L", // C for Card, L for Loan
      Amount: this.TotalAmount,
      ServiceType: "LL",
    };

    this.commonP.presentLoading();
    this.topupservice
      .InititePaymentService(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response.code == 1) {


          this.transactionRefId = data?.response?.content?.id;
          this.cookieService.set(
            "referenceId",
            this.transactionRefId,
            true
          );

          window.location.href = data?.response?.content?.url;
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  CheckStatus() {
    //
    if (this.PaymentRequired) {


      this.cookieService.set(
        "internalid",
        this.selectedLoanDetail?.internalId,
        true
      );
      this.cookieService.set("ServiceType", this.RLServiceid, true);
      this.cookieService.set("Product", "C", true);
      this.InititePaymentService();
    }
  }
  async LettersRequest() {
    //
    let data = {
      internalId: this.selectedLoanDetail?.internalId,
      ServiceType: this.RLServiceid,
      Product: "L", // C for card, L for loan
    };
    await this.commonP.presentLoading();
    this.cardService
      .RequestingLetters(data, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          let letterRequest = true;

          let email = this.auth?.detailuser?.emailId;
          let Refid = data?.response?.content?.loan?.referenceNumber;
          if (this.PaymentRequired) {

            this.cookieService.set("Refid", Refid, true);
            this.cookieService.set("email", email, true);
            this.cookieService.set("ReqLetter", "ReqLetter", true);
          } else {
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { letterRequest, email, Refid },
            });
            await this.commonP.hideLoading();
          }
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  selectMonth() {
    this._router.navigateByUrl("/MonthSelect");
  }
  payLoanSuccess() {
    this._router.navigateByUrl("/PayLoanSuccess");
  }
  loanDeferInstalment() {
    this._router.navigateByUrl("/LoanDeferInstalment");
  }

}
